'use client';

import Drawer from '@/components/Drawer';
import type { MaterialWithSoftTag } from '@/features/match-maker/utils/match-maker.types';
import type React from 'react';
import { CalculationDetailCard } from '../../components/calculation-detail-card';

type TagDetailDialogProps = {
  tagId: string | null;
  onClose: () => void;
  tags: Array<MaterialWithSoftTag>;
};

const TagDetailDialog: React.FC<TagDetailDialogProps> = ({
  tagId,
  onClose,
  tags,
}) => {
  if (!tagId) return null;
  const selectionDetail = tags.find(tag => tag.id === tagId);
  if (!selectionDetail) return null;

  return (
    <Drawer
      isOpen={!!tagId}
      onClose={onClose}
      title="Calculation method details"
      widthClass="w-[500px]"
    >
      <CalculationDetailCard tag={selectionDetail} />
    </Drawer>
  );
};

export default TagDetailDialog;
